import { render, staticRenderFns } from "./orders-prepare-table.vue?vue&type=template&id=5ad39e66&scoped=true"
import script from "./orders-prepare-table.vue?vue&type=script&lang=js"
export * from "./orders-prepare-table.vue?vue&type=script&lang=js"
import style0 from "./orders-prepare-table.vue?vue&type=style&index=0&id=5ad39e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad39e66",
  null
  
)

export default component.exports